import React from "react";
import { useTranslation } from "react-i18next";

import DemoModeSvc from "../../services/demoModeSvc";

import "./styles.scss";

export const DemoModeBanner = () => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`demoModeBanner.${key}`);

  const demoMode = DemoModeSvc.current;

  const isDemoModeOn = demoMode.isDemoModeOn;

  const handleReturnToNormalMode = () => {
    demoMode.toggleDemo();
  };

  if (!isDemoModeOn) {
    return null;
  }

  return (
    <div className="demo-mode-banner">
      <span>{t("explanation")}</span>
      <button className="btn" onClick={handleReturnToNormalMode}>
        {t("return_to_normal_mode")}
      </button>
    </div>
  );
};
